var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8841 2.49157C12.5381 1.83614 11.4621 1.83614 11.1161 2.49157L2.11627 19.5288C2.03556 19.6815 1.99564 19.8526 2.00038 20.0254C2.00512 20.1981 2.05436 20.3667 2.14333 20.5148C2.23229 20.6629 2.35796 20.7854 2.50811 20.8704C2.65826 20.9554 2.8278 21 3.00025 21H20.9999C21.1724 21.0004 21.342 20.9559 21.4922 20.871C21.6424 20.7861 21.7681 20.6637 21.8571 20.5156C21.946 20.3675 21.9951 20.1989 21.9997 20.0261C22.0042 19.8533 21.964 19.6823 21.8829 19.5298L12.8841 2.49157ZM13.0001 17.9934H11.0001V15.9891H13.0001V17.9934ZM11.0001 13.9847V8.97373H13.0001L13.0011 13.9847H11.0001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorSolid);
export default __webpack_public_path__ + "static/media/error-solid.460211d738b1e75b9d7f6c94cf61a605.svg";
export { ForwardRef as ReactComponent };